import { BaseResponse } from './base.response';
import { Customer } from '../models';

export class CustomerResponse extends BaseResponse {

  public customers: Customer[];

}
